import { render, staticRenderFns } from "./photo-material.vue?vue&type=template&id=3e0355fe&scoped=true&"
import script from "./photo-material.vue?vue&type=script&lang=js&"
export * from "./photo-material.vue?vue&type=script&lang=js&"
import style0 from "./photo-material.vue?vue&type=style&index=0&id=3e0355fe&scoped=true&lang=scss&"
import style1 from "./photo-material.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0355fe",
  null
  
)

export default component.exports